import {ILoggerService, LogError} from './logger.service.interface';
import {Check} from '@sparkware/app-utils';

export class ConsoleLoggerService implements ILoggerService {

  constructor(private _debugMode: boolean) {

  }

  errorLogs: LogError[] = [];

  debug(message: string): void {
    console.debug(message);
  }

  info(message: string): void {
    console.info(message);
  }

  warning(message: string): void {
    console.warn(message);
  }

  error(message: string, error?: any): void {
    if(error) {
      if(Check.isObject(error) || Check.isArray(error)) {
        message = `${message}; Error details: ${JSON.stringify(error)}`;
      } else {
        message = `${message}; Error details: ${error}`;
      }
    }

    this._addErrorLog(message);
    console.error(message);
  }

  private _addErrorLog(message: string) {
    if(!this._debugMode) {
      return;
    }

    if (this.errorLogs.length === 30) {
      this.errorLogs.splice(0, 1);
    }

    this.errorLogs.push({message: message, date: new Date()});
  }

}
